import { PlannerMemo } from 'mixs/orders/planner_base';
import { Global, CellPositionLocal, LineMemoLocal }  from "mixs/orders/planner/model";
class Cell extends PlannerMemo {
  newCellPosition(){
    return new CellPositionLocal(this.opts.baseDate, this.opts.start_time, this.opts.end_time);
  }
  newLineMemoLocal(localIndex){
    return new LineMemoLocal(this.opts.line_id, this.opts.id, localIndex, this.opts.baseDate);
  }
}
riot.mixin('tasks.schedules-cell', Cell as riot.TagMixin)
